import { getSystemInfoSync } from '@max/meituan-uni-system';
//临时方案， 获取到的位置信息有偏差
export const setDistanceTop = (y, isIos) => {
    let addValue = 0;
    if (y < 800) {
        addValue = Math.floor((800 - y) / 50) * (isIos ? 2 : 4.5);
        if (y < 25)
            addValue += 3;
    }
    else if (y < 900) {
        addValue = -15;
    }
    return y + addValue;
};
export const { statusBarHeight, screenHeight, screenWidth, appId = '', platform } = getSystemInfoSync() || {};
export const isAndroid = platform === 'android' || platform === 'Android';
export function reverseRem(size, factor = 375, foldAdapter = false, screenWidthBelow360NeedScale = false) {
    if (screenWidth > 0 && screenHeight / screenWidth <= 1.33 && !foldAdapter) {
        return size;
    }
    if (!screenWidthBelow360NeedScale && screenWidth < 360) {
        return size;
    }
    return size / screenWidth * factor;
}
export function getImage(uri) {
    return {
        uri
    };
}
